<template>
  <div id="top-nav">
    <div class="topnav shadow-lg">
      <div class="container-fluid">
        <nav class="navbar navbar-light navbar-expand-lg topnav-menu">
          <div class="collapse navbar-collapse" id="topnav-menu-content">
            <ul class="navbar-nav">
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle arrow-none"
                  href="javascript:void(0)"
                  id="nav-platform-index"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-if="
                    routesStartPath.startsWith('/platform') || routesStartPath.startsWith('/index')
                  "
                  @click="platForm"
                >
                  平台概况
                </a>
              </li>
              <!-- <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle arrow-none"
                  href="javascript:void(0)"
                  id="nav-platform-index"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-if="
                    routesStartPath.startsWith('/platform') || routesStartPath.startsWith('/index')
                  "
                  @click="attributeCourse"
                >
                  属性课程
                </a>
              </li> -->
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle arrow-none"
                  href="javascript:void(0)"
                  id="nav-invalid-course"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-if="
                    (routesStartPath.startsWith('/platform') ||
                      routesStartPath.startsWith('/index')) &&
                    [2, 3].includes(userInfo.role_id)
                  "
                  @click="invalidCourse"
                >
                  无效课程
                </a>
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle arrow-none"
                  href="javascript:void(0)"
                  id="nav-access-analyse"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-if="
                    routesStartPath.startsWith('/platform') || routesStartPath.startsWith('/index')
                  "
                  @click="accessAnalyse"
                >
                  访问分析
                </a>
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle arrow-none"
                  href="javascript:void(0)"
                  id="nav-course-index"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-if="routesStartPath.startsWith('/course')"
                  @click="course"
                >
                  所有课程
                </a>
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle arrow-none"
                  href="javascript:void(0)"
                  id="nav-course-rank"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-if="routesStartPath.startsWith('/course')"
                  @click="courseRank"
                >
                  课程排行
                </a>
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle arrow-none"
                  href="javascript:void(0)"
                  id="nav-term-index"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-if="routesStartPath.startsWith('/term')"
                  @click="term"
                >
                  学期基本概况
                </a>
              </li>
              <!-- <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle arrow-none"
                  href="javascript:void(0)"
                  id="nav-term-reports"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-if="routesStartPath.startsWith('/term')"
                  @click="termReports"
                >
                  学期报告
                </a>
              </li> -->
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle arrow-none"
                  href="javascript:void(0)"
                  id="nav-supervision-index"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-if="routesStartPath.startsWith('/supervision')"
                  @click="supervision"
                >
                  学院建设情况统计
                </a>
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle arrow-none"
                  href="javascript:void(0)"
                  id="nav-supervision-course"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-if="routesStartPath.startsWith('/supervision')"
                  @click="courseStatistic"
                >
                  课程建设情况统计
                </a>
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle arrow-none"
                  href="javascript:void(0)"
                  id="nav-supervision-teacher"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-if="routesStartPath.startsWith('/supervision')"
                  @click="teacherStatistic"
                >
                  课程教师行为统计
                </a>
              </li>
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle arrow-none"
                  href="javascript:void(0)"
                  id="nav-supervision-student"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-if="routesStartPath.startsWith('/supervision')"
                  @click="studentStatistic"
                >
                  课程学生行为统计
                </a>
              </li>
            </ul>
            <!-- end navbar-->
          </div>
          <!-- end .collapsed-->
        </nav>
      </div>
      <!-- end container-fluid -->
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'SubNav',
  inject: ['reload'],
  data() {
    return {
      routepath: '',
    }
  },
  computed: {
    // onRoutes() {
    //   const path = this.$route.path
    //   // 在路由配置文件中设置自定义的路由路径到meta.activeMenu属性中，来控制菜单自定义高亮显示
    //   // meta中 有activeMenu 字段的子页面，都会显示高亮
    //   console.log('path:', path)

    //   return path
    // },

    // activeMenu() {
    //   const clickRoutes = this.$route
    //   console.log('clickRoutes', clickRoutes)
    //   const { meta, path } = clickRoutes

    //   if (meta.activeMenu) {
    //     return meta.activeMenu
    //   }
    //   return path
    // },
    ...mapState({
      userInfo(state) {
        return state.commom.userInfo
      },
      roleList(state) {
        return state.commom.roleList
      },
      routesStartPath() {
        console.log('this.$route.path', this.$route.path)
        return this.$route.path
      },
    }),
    routesStartPath() {
      console.log('this.$route.path', this.$route.path)
      return this.$route.path
    },
  },
  mounted() {},
  watch: {},
  beforeRouteEnter(to, from, next) {
    console.log('to', to)
    console.log('from', from)
    console.log('next', next)
  },
  methods: {
    refresh() {
      this.reload()
    },
    platForm() {
      this.$router.push({
        path: '/index',
      })
    },
    attributeCourse() {
      this.$router.push({
        path: '/platform/attributeCourse',
      })
    },
    invalidCourse() {
      this.$router.push({
        path: '/platform/invalidCourse',
      })
    },
    accessAnalyse() {
      this.$router.push({
        path: '/platform/accessAnalyse',
      })
    },
    course() {
      this.$router.push({
        path: '/course',
      })
    },
    courseRank() {
      this.$router.push({
        path: '/course/courseRank',
      })
    },
    term() {
      this.$router.push({
        path: '/term',
      })
    },
    termReports() {
      this.$router.push({
        path: '/term/reports',
      })
    },
    supervision() {
      this.$router.push({
        path: '/supervision',
      })
    },
    courseStatistic() {
      this.$router.push({
        path: '/supervision/courseStatistic',
      })
    },
    teacherStatistic() {
      this.$router.push({
        path: '/supervision/teacherStatistic',
      })
    },
    studentStatistic() {
      this.$router.push({
        path: '/supervision/studentStatistic',
      })
    },
    isPlatform() {
      if (this.routesStartPath === '/term' || this.routesStartPath === '/index') {
        return true
      } else {
        return false
      }
    },
    isCourse() {
      if (this.routesStartPath === '/course') {
        return true
      } else {
        return false
      }
    },
    isSupervision() {
      if (this.routesStartPath === '/supervision') {
        return true
      } else {
        return false
      }
    },
  },
}
</script>

<style scoped>
.navbar-light .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.7);
}
.nav-link.active {
  color: #ffffff !important;
  font-weight: bold;
}
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-left: 0 !important;
}
.topnav .navbar-nav .nav-item:first-of-type .nav-link {
  padding-left: 1.1rem;
}
</style>
